var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar -right"},[_c('div',{staticClass:"inside"},[_c('phone-block'),_c('hr',{staticClass:"line"}),_vm._l((_vm.users),function(one,index){return _c('user-avatar',{key:'user-'+index})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }